export default {
  GENERATE_STATIC_PAGE_PERMALINK_REQUEST: 'GENERATE_STATIC_PAGE_PERMALINK_REQUEST',
  GENERATE_STATIC_PAGE_PERMALINK_SUCCESS: 'GENERATE_STATIC_PAGE_PERMALINK_SUCCESS',
  GENERATE_STATIC_PAGE_PERMALINK_FAILURE: 'GENERATE_STATIC_PAGE_PERMALINK_FAILURE'
}
